<template>
    <el-dialog
            title="Unassign a sales rep"
            :visible.sync="isModalVisible"
            width="500px">

        <el-form label-width="120px">
            <el-form-item label="From">
                <el-date-picker
                        v-model="from"
                        type="month"
                        value-format="yyyy-MM-dd"
                        placeholder="From">
                </el-date-picker>
            </el-form-item>

        </el-form>

        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onUnassign">Unassign</el-button>
              </span>
    </el-dialog>
</template>

<script>
    export default {
        name: 'assign-salesman-modal',
        props: {
            visible: Boolean
        },
        data() {
            return {
                from: moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'),
                isModalVisible: this.visible
            };
        },
        methods: {
            validate(){
                let errorMessage = '';
                if(!this.from){
                    errorMessage += "Please select from. <br/>";
                }

                return errorMessage;
            },
            onUnassign(){
                let errorMessages = this.validate();
                if(errorMessages){
                    this.showError(errorMessages);
                    return;
                }
                this.hideStatusMessages();
                this.$emit('unassign', this.from);
                this.isModalVisible = false;
            }
        },
        watch: {
            visible(){
                this.isModalVisible = this.visible;
                if(this.visible){
                    this.from = moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD');
                    this.isModalVisible = this.visible;
                }
            },
            isModalVisible(){
                this.$emit('update:visible', this.isModalVisible);
            }
        }
    }
</script>
